import React, { useState, useEffect } from 'react';
import { WALLET_TYPES, WALLETS } from '../../utils/Enum';
import { useAuth } from '../../contexts/AuthContext';
import { Form, FormButton1, FormH1, FormText } from '../CustomForm/CustomFormElements';
import { 
  MenuButtonContent, 
  MenuButtonDescription, 
  MenuButtonIconWrapper, 
  MenuButtonTitle, 
  MenuGrid, 
  MenuImage, 
  MenuItemButton 
} from '../MenuOptions/MenuOptionsElements';
import xummLogo from "../../images/xumm_app_logo.png";
import walletConnectLogo from "../../images/wallet_connect_logo.jpg";
import gemWalletLogo from "../../images/gem_wallet_logo.png";
import crossmarkLogo from "../../images/crossmark_wallet_logo.png";
import joeyWalletLogo from "../../images/joey_wallet_logo.png";
import QRCodeForm from '.';
import WalletConnect, { JoeyWalletConnect } from './WalletConnect';
import GemWallet from './GemWallet';
import { FormWrap } from './QrCodeFormElements';
import CrossMark from './CrossMark';

const WalletSelector = ({
  heading,
  body,
  type,
  cancelQr,
  onSuccess,
  onFail,
}) => {
    const { currentUser } = useAuth();
    
    // Initialize state
    const [selectedWallet, setSelectedWallet] = useState(
      currentUser?.uid && localStorage.getItem('WalletType') 
        ? localStorage.getItem('WalletType') 
        : undefined
    );

    // 1. Detect Screen Size (Mobile/Tablet vs Desktop)
    const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 1024);

    useEffect(() => {
        const handleResize = () => setIsSmallScreen(window.innerWidth < 1024);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    // Map logos to IDs to avoid index errors when filtering
    const walletLogos = {
      [WALLET_TYPES.XAMAN]: xummLogo,
      [WALLET_TYPES.WALLET_CONNECT]: walletConnectLogo,
      [WALLET_TYPES.GEM_WALLET]: gemWalletLogo,
      [WALLET_TYPES.CROSSMARK]: crossmarkLogo,
        [WALLET_TYPES.JOEY_WALLET]: joeyWalletLogo
    };

    // 2. Filter logic: Only Xaman and WalletConnect for mobile/tablets
    const availableWallets = isSmallScreen 
        ? WALLETS.filter(w => w.id === WALLET_TYPES.XAMAN || w.id === WALLET_TYPES.WALLET_CONNECT)
        : WALLETS;

    // Helper to persist the correct wallet type on success
    const handleWalletSuccess = (val, walletId) => {
        onSuccess(val);
        if (currentUser?.uid) {
            localStorage.setItem('WalletType', walletId);
        }
    };

    if (!selectedWallet) {
      return (
        <FormWrap>
            <Form onSubmit={(e) => e.preventDefault()}>
              <FormH1> Choose your Wallet </FormH1>
              <FormText>
                Select your preferred wallet to begin the registration process.
              </FormText>
              
              <MenuGrid
                style={{ 
                    gridTemplateColumns: isSmallScreen ? "1fr" : "repeat(2, 1fr)", 
                    padding: "2%" 
                }}
              >
                {availableWallets.map((wallet) => (
                    <MenuItemButton
                      key={wallet.id}
                      onClick={() => setSelectedWallet(wallet.id)}
                    >
                      <MenuButtonIconWrapper>
                        <MenuImage 
                            style={{ borderRadius: '50%' }} 
                            src={walletLogos[wallet.id]} 
                        />
                      </MenuButtonIconWrapper>
                      <MenuButtonContent>
                        <MenuButtonTitle>{wallet.name}</MenuButtonTitle>
                        
                        {/* 3. Hide descriptions on small screens */}
                        {!isSmallScreen && (
                            <MenuButtonDescription>
                              {wallet.description}
                            </MenuButtonDescription>
                        )}
                      </MenuButtonContent>
                    </MenuItemButton>
                ))}
              </MenuGrid>
              
              <FormButton1 transparent onClick={() => cancelQr()}>
                Cancel
              </FormButton1>
            </Form>
        </FormWrap>
      );
    }

    return (
      <>
        {selectedWallet === WALLET_TYPES.XAMAN && (
            <QRCodeForm 
                body={body} 
                heading={heading}
                type={type}
                cancelQr={cancelQr}
                onSuccess={(val) => handleWalletSuccess(val, WALLET_TYPES.XAMAN)}
                onFail={onFail}
            />
        )}
        {selectedWallet === WALLET_TYPES.WALLET_CONNECT && (
            <WalletConnect 
                body={body} 
                heading={heading}
                type={type}
                cancelQr={cancelQr}
                onSuccess={(val) => handleWalletSuccess(val, WALLET_TYPES.WALLET_CONNECT)}
                onFail={onFail} 
            />
        )}
        {selectedWallet === WALLET_TYPES.JOEY_WALLET && (
            <JoeyWalletConnect 
                body={body} 
                heading={heading}
                type={type}
                cancelQr={cancelQr}
                onSuccess={(val) => handleWalletSuccess(val, WALLET_TYPES.JOEY_WALLET)}
                onFail={onFail} 
            />
        )}
        {selectedWallet === WALLET_TYPES.GEM_WALLET && (
            <GemWallet 
                body={body} 
                heading={heading}
                type={type}
                cancelQr={cancelQr}
                onSuccess={(val) => handleWalletSuccess(val, WALLET_TYPES.GEM_WALLET)}
                onFail={onFail} 
            />
        )}
        {selectedWallet === WALLET_TYPES.CROSSMARK && (
            <CrossMark 
                body={body} 
                heading={heading}
                type={type}
                cancelQr={cancelQr}
                onSuccess={(val) => handleWalletSuccess(val, WALLET_TYPES.CROSSMARK)}
                onFail={onFail}
            />
        )}
      </>
    );
}

export default WalletSelector;